import React, { useMemo } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import Button from 'components/CustomButtons/Button';
import ComboDetailModal from './ComboDetailModal';
import { useModal } from 'hooks/useModal';
import { Edit } from '@material-ui/icons';
import Add from '@material-ui/icons/Add';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código Producto', accessor: 'Code' },
  { Header: 'Descripción', accessor: 'ItemName' },
  { Header: 'Cantidad', accessor: 'Quantity' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ProductDetails(props) {
  const { dataProduct, showNotify, reload } = props;
  const [detailModel, setDetailModelOpen] = useModal();

  const details = useMemo(() => {
    if ('details' in dataProduct) {
      return dataProduct.details;
    }
    return [];
  }, [dataProduct]);

  if (dataProduct.TreeType === 'N') {
    return (
      <CardContainer title={'Detalles de producto'} icon={null}>
        <h2>El producto tiene que ser tipo combo</h2>
      </CardContainer>
    );
  }

  return (
    <CardContainer
      title={'Detalles de producto'}
      icon={<Add />}
      onClick={() => {
        setDetailModelOpen({
          father_product_id: dataProduct.id,
          base_business_partner_id: dataProduct.base_business_partner_id,
        });
      }}
    >
      <ComboDetailModal model={detailModel} setOpen={setDetailModelOpen} showNotify={showNotify} reload={reload} />
      <ReactTable
        columns={columns}
        data={details.map((detail, index) => {
          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <Button
                  justIcon
                  round
                  simple
                  color="warning"
                  onClick={() => {
                    setDetailModelOpen({
                      ...detail,
                      base_business_partner_id: dataProduct.base_business_partner_id,
                    });
                  }}
                >
                  <Edit />
                </Button>
              </div>
            ),
            Code: detail.Code,
            ItemName: detail.ItemName,
            Quantity: detail.Quantity,
          };
        })}
      />
    </CardContainer>
  );
}

export default ProductDetails;
